import { BottomNavigation, BottomNavigationAction, Box, Paper, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetEntityState } from '../Common/Entity/actions/reduxActions';
import { getSelectedEntityStatus } from '../Reducers/Entity/EntityReducer';
import { toast } from 'react-toastify';
import { STATUS } from '../Common/Entity/Enums';

const BottomTabBar = ({ 
  tabConfig, 
  firmOnboarded, 
  manufacturerSelected = null,
  onFirmModalShow,
  onManufacturerModalShow = null 
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPath = location.pathname;

  const entityStatus = useSelector(getSelectedEntityStatus);
  const handleTabChange = (event, newValue) => {
    // Block navigation if entity is INACTIVE
    if (entityStatus === STATUS.PENDING) {
      toast.error('Selected entity is inactive. Please select an active entity.');
      return;
    }
    // Check if firm is onboarded first
    if (!firmOnboarded && onFirmModalShow) {
      onFirmModalShow();
      return;
    }
    // Check if manufacturer is selected (only if firm is onboarded)
    if (firmOnboarded && !manufacturerSelected && onManufacturerModalShow) {
      onManufacturerModalShow();
      return;
    }
    navigate(newValue);
  };
  return (
    <>
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        border: 'none',
        boxShadow:"none",

      }}
    >
      <BottomNavigation
        value={currentPath}
        onChange={handleTabChange}
        sx={{ 
            height: 70,
            borderRadius: '16px', 
            border: 'none',
            boxShadow: '0px 2px 8px 0px #0000001A',
            p: 0,
            alignItems: 'center',
            justifyContent: 'center',
        }}
      >
        {tabConfig.map((tab) => {
            const isSelected = currentPath === tab.route;
            return (
                <BottomNavigationAction
                    key={tab.key}
                    label={tab.label}
                    value={tab.path}
                    icon={isSelected ? tab.activeIcon : tab.inactiveIcon}
                    showLabel
                    sx={{
                      padding: 0,
                      alignContent: 'center',
                      minWidth: 'unset',
                      ".MuiBottomNavigationAction-label": {
                        fontSize: "11px",
                        transition: "none",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: isSelected ? "#995A00" : "#666666",
                      },
                      "&.Mui-selected": {
                        ".MuiBottomNavigationAction-label": {
                          color: "#995A00",
                          fontSize: "11px",
                          fontWeight: 600,
                        },
                        ".MuiSvgIcon-root": {
                          color: "#995A00",
                        },
                      },
                    }}
                />
            );
        })}
      </BottomNavigation>
    </Paper>
    </>
  );
};

export default BottomTabBar;

